import { render, staticRenderFns } from "./last-news-item.vue?vue&type=template&id=5e27c9c4&scoped=true&"
import script from "./last-news-item.vue?vue&type=script&lang=js&"
export * from "./last-news-item.vue?vue&type=script&lang=js&"
import style0 from "./last-news-item.vue?vue&type=style&index=0&id=5e27c9c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27c9c4",
  null
  
)

export default component.exports